import { render, staticRenderFns } from "./salesInfo.vue?vue&type=template&id=04740e76&scoped=true&"
import script from "./salesInfo.vue?vue&type=script&lang=js&"
export * from "./salesInfo.vue?vue&type=script&lang=js&"
import style0 from "./salesInfo.vue?vue&type=style&index=0&id=04740e76&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04740e76",
  null
  
)

export default component.exports